<template>
  <div class="default-modal">
    <el-dialog
      width="70%"
      top="15vh"
      v-model="exportReportsDialogVisisble"
      @close="close"
    >
      <div class="export-dialog-header">
        <div class="export-header-part">
          <h3>CASE REPORT</h3>
        </div>

        <el-button
          size="medium"
          class="el-white"
          type="info"
          plain
          @click="close"
        >
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
        /></el-button>
      </div>
      <div
        class="selected-string"
        v-if="selected_case_type && selected_case_type.length"
      >
        <h3>
          Selected Case Type :
          <span class="value">{{ getCaseTypeMap(selected_case_type) }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="
          selected_case_types &&
          Array.isArray(this.selected_case_types) &&
          this.selected_case_types.length
        "
      >
        <h3>
          Selected Case Type :
          <span
            class="value"
            v-for="(caseType, index) of getCaseTypes(selected_case_types)"
            :key="index"
            >{{ caseType }}
            <span v-if="index + 1 < selected_case_types.length">,</span>
          </span>
        </h3>
      </div>
      <div class="selected-string" v-if="priority === 'Stat' || priority === 'Routine'">
        <h3>
          Priority:
          <span class="value">{{ priority === 'Stat' ? 'STAT' : 'Routine' }}</span>
        </h3>
        </div>
      <div class="selected-string" v-if="dateOfBirth && dateOfBirth.length">
        <h3>
          Selected DOB :
          <span class="value">{{ selectedDob(selected_dob) }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="selected_date_type && selected_date_type.length"
      >
        <h3>
          Selected Date Type :
          <span class="value">{{ getDateTypeMap(selected_date_type) }} </span>
        </h3>
      </div>
      <div class="selected-string" v-if="selected_from_date">
        <h3>
          Selected From Date :
          <span class="value">{{ selectedDob(selected_from_date) }} </span>
        </h3>
      </div>
      <div class="selected-string" v-if="selected_to_date">
        <h3>
          Selected To Date :
          <span class="value">{{ selectedDob(selected_to_date) }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="search_first_name && search_first_name.length"
      >
        <h3>
          Search Patient Name :
          <span class="value">{{ search_first_name }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="search_last_name && search_last_name.length"
      >
        <h3>
          Search Last Name :
          <span class="value">{{ search_last_name }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="search_case_statuses && search_case_statuses.length"
      >
        <h3>
          Selected Status :
          <span class="value" v-if="search_case_statuses == 'COMPLETE'"
            >{{ getStatusType(search_case_statuses) }}
          </span>

          <span class="value" v-else
            >{{ getStatusType(search_case_statuses) }}
          </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="selected_covid_status && selected_covid_status.length"
      >
        <h3>
          Selected Covid Status :
          <span class="value">{{ selected_covid_status }}</span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="
          search_case_status &&
          Array.isArray(this.search_case_status) &&
          this.search_case_status.length
        "
      >
        <h3>
          Selected Status :
          <span
            class="value"
            v-for="(caseStatus, index) of getStatusMap(search_case_status)"
            :key="index"
            >{{ caseStatus }}
            <span v-if="index + 1 < search_case_status.length">,</span>
          </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="selected_hospital && selected_hospital.filter(Boolean).length > 0"
      >
        <h3>
          Selected Ordering Facility :
          <span class="value"
            >{{ getSelectedHospital(selected_hospital) }}
          </span>
        </h3>
      </div>
      <div class="selected-string" v-if="selected_user && selected_user.length">
        <h3>
          Selected Assigned to :
          <span class="value">{{ getSelectedUser(selected_user) }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="
          selected_marketer &&
          Array.isArray(this.selected_marketer) &&
          this.selected_marketer.length
        "
      >
        <h3>
          Selected Marketer :
          <span
            class="value"
            v-for="(marketer, index) of selected_marketer"
            :key="index"
            >{{ getSelectedUser(marketer) }}
          </span>
        </h3>
      </div>

      <div
        class="selected-string"
        v-if="selected_physician && selected_physician.length"
      >
        <h3>
          Selected Physician :
          <span class="value"
            >{{ getSelectedPhysician(selected_physician).name }}
          </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="selected_string && selected_string.length"
      >
        <h3>
          Selected String :
          <span class="value">{{ selected_string }} </span>
        </h3>
      </div>
      <div>
        <div
          class="selected-string"
          v-if="
            search_billed_status &&
            (search_billed_status.includes('Unbilled') ||
              search_billed_status.includes('PENDING'))
          "
        >
          <h3>
            Selected Billed Status :
            <span
              class="value"
              v-for="(biling, index) in search_billed_status"
              :key="index"
              >{{ biling }}
            </span>
          </h3>
        </div>
        <div
          v-if="
            search_billed_status &&
            [
              'Billed',
              'Billed with Exception',
              'Client',
              'Coding',
              'Exception',
              'On hold',
              'Patient',
              'Exception Reviewed'
            ].includes(search_billed_status)
          "
          class="selected-string"
        >
          <h3>
            Selected Billed Status :
            <span class="value">{{ search_billed_status }}</span>
          </h3>
        </div>
      </div>

      <div class="selected-string" v-if="selected_emr && selected_emr.length">
        >
        <h3>
          Selected EMR :
          <span class="value">{{ selected_emr }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="selected_accession_id && selected_accession_id.length"
      >
        <h3>
          Selected Barcode :
          <span class="value">{{ selected_accession_id }} </span>
        </h3>
      </div>
      <div class="selected-string" v-if="selected_billing_assigne">
        <h3>
          Selected Billing Assigne :
          <span class="value"
            >{{ getSelectedBillingUser(selected_billing_assigne) }}
          </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="search_billed_sub_status && search_billed_sub_status.length"
      >
        <h3>
          Selected Billing Sub Status :
          <span class="value">{{ search_billed_sub_status }} </span>
        </h3>
      </div>
      <div class="dialog-body">
        <div class="export-popup-body" v-loading="loading">
          <div class="select-fields">
            <el-checkbox-group v-model="activeFieldList">
              <ul class="select-fields-list">
                <li
                  class="search-checkbox"
                  v-for="(item, index) in casesExportFields"
                  :key="index"
                >
                  <el-checkbox :label="item.value">
                    {{ item.label }}
                  </el-checkbox>
                </li>
              </ul>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div class="dialog-footer export-footer w-95">
        <el-button
          class="cancel-button"
          @click="handleClear"
          :disabled="!this.activeFieldList.length"
          >CLEAR ALL</el-button
        >
        <el-button class="cancel-button" @click="handleCheckAllChange"
          >SELECT ALL</el-button
        >
        <el-button class="cancel-button" @click="close">CANCEL</el-button>
        <el-button
          class="blue-save-button"
          @click="downloadAmendedCases"
          v-if="selected_date_type == 'amended_date'"
        >
          DOWNLOAD
        </el-button>
        <el-button class="blue-save-button" @click="downloadCases" v-else>
          DOWNLOAD
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import AppHelper from "@/mixins/AppHelper";
import exportExcelHelper from "@/mixins/exportExcelHelper";
import FilterHelper from "@/mixins/FilterHelper";
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import moment from "moment";
export default {
  mixins: [
    UserPermissionsHelper,
    exportExcelHelper,
    caseDataHelper,
    AppHelper,
    FilterHelper,
  ],
  props: [
    "selected_dob",
    "selected_case_type",
    "selected_hospital",
    "selected_user",
    "selected_marketer",
    "selected_physician",
    "selected_string",
    "selected_emr",
    "selected_accession_id",
    "search_case_status",
    "selected_from_date",
    "selected_to_date",
    "search_first_name",
    "search_last_name",
    "selected_date_type",
    "selected_case_types",
    "search_case_statuses",
    "selected_covid_status",
    "selected_tests",
    "pregnancy",
    "search_billed_status",
    "selected_billing_assigne",
    "sendout",
    "emr_not_sent",
    "selected_exception",
    "search_billed_sub_status",
    "replaced_insurance",
    "priority",
    "fromDate",
    "toDate"
 
  ],
  computed: {
    mappedSelectedOptions() {
      return this.activeFieldList.map((option) => {
        return this.exportExtraCasesExcelFields.find(
          (opt) => opt.value === option
        );
      });
    },
    ...mapGetters("cases", [
      "getAllCases",
      "getCaseDeleteStatus",
      "getCaseDeleteError",
      "getUpdateCaseStatus",
      "getAllCaseErrors",
      "getUpdateCaseCovidStatus",
      "getDownloadCaseDataStatus",

    ]),
    
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("userAccounts", ["getAllUsers"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
      "getNewLabGroupWiseTestsData",
    ]),
    ...mapGetters("auth", ["getAuthenticatedUser" ,"getUserAllowedLabs" ,   "getUserLabDetails" ]),

    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "Active";
        } else if (status == "COMPLETE") {
          return "Finalized";
        } else if (status == "TEST_REPORTS") {
          return "PROCESSING";
        } else if (status == "REJECTED") {
          return "Rejected";
        } else if (status == "PENDING") {
          return "Pending";
        } else if (status == "TO_BE_COLLECTED") {
          return "Future";
        } else {
          return "";
        }
      };
    },
    getCaseTypeMap() {
      return (status) => this.caseTypeMap[status];
    },
    getDateTypeMap() {
      return (date) => this.dateTypeMap[date];
    },
    getStatusMap() {
      return (status) => {
        return (status || []).map((e) => this.statusMap[e]);
      };
    },
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
    selectedDob() {
      return (selected_dob) => moment(selected_dob).format("MM-DD-YYYY");
    },
  },
  data() {
    return {
      exportReportsDialogVisisble: true,
      fieldList: [],
      activeFieldList: [],
      checkAll: true,
      loading: false,
      date_type: "",
      status: "",
      statusMap: caseConstants.STATUS_TYPE_MAP,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      caseTypes: caseConstants.CASE_TYPES_DATA,
      dateTypeMap: {
        collection_date: "Collection",
        received_date: "Received",
        finalized_date: "Reported",
        amended_date: "Amended",
      },
      dateOfBirth: "",

      roleGroups: {
        labUsers: [
          "LAB_ADMIN",
          "LAB_SUPER_ADMIN",
          "LAB_TECHNOLOGIST",
          "LAB_DATA_ASSISTANT",
          "ADMIN",
          "LAB_MANAGER",
          "LAB_DATA_ADMIN",
          "QC_MANAGER",
        ],
        facilityUsers: [
          "HOSPITAL_PHYSICIAN",
          "HOSPITAL_ADMIN",
          "HOSPITAL_ACCOUNT_MANAGER",
          "HOSPITAL_MARKETING_MANAGER",
          "SALES_DIRECTOR",
          "MARKETER",
          "ACCOUNT_MANAGER",
        ],
        billingUsers: [
          "BILLING_REPRESENTATIVE",
          "AR_LEAD",
          "AR_EXECUTIVE",
          "CP_LEAD",
          "CODING_LEAD",
          "CODING_EXECUTIVE",
          "POSTING_EXECUTIVE",
          "SR_FTE",
        ],
      },
      casesExportFields: [],
    };
  },
  created() {
    // this.activeFieldList = [
    //   ...this.defaultExportCasesExcelFields.map((opt) => opt.value),
    // ];
    const userRole = this.getCurrentUser(); // Get the current user's role
    let userGroup;
    if (this.roleGroups.labUsers.includes(userRole)) {
      userGroup = "labUsers";
    } else if (this.roleGroups.facilityUsers.includes(userRole)) {
      userGroup = "facilityUsers";
    } else if (this.roleGroups.billingUsers.includes(userRole)) {
      userGroup = "billingUsers";
    }

    const hasDLWTX = this?.getUserLabDetails?.lab_code !== "DLW-TX"

    if (hasDLWTX) {
      this.exportExtraCasesExcelFields = this.exportExtraCasesExcelFields.filter(item => 
        !(item.label === 'Completed Tests' && item.value === 'completed_tests') &&
        !(item.label === 'Pending Tests' && item.value === 'pending_tests')
      );
    }
    const accessibleFields = this.groupBasedFields[userGroup] || [];
    this.casesExportFields = [];

   
    // Filter exportExtraCasesExcelFields based on accessible fields
    this.exportExtraCasesExcelFields.forEach((obj) => {
      if (accessibleFields.includes(obj.value)) {
        this.casesExportFields.push(obj);
      }
    });
    this.activeFieldList = this.defaultExportCasesExcelFields
      .filter((field) => accessibleFields.includes(field.value))
      .map((field) => field.value);
  },
  async mounted() {
    this.loading = true;
    this.status = this.search_case_status;
    if (this.selected_dob) {
      this.dateOfBirth = this.selectedDob(this.selected_dob);
    }
    this.loading = false;
  },
  methods: {
    getCurrentUser() {
      return this.getAuthenticatedUser.user_type;
    },
    handleClear() {
      this.activeFieldList = [];
      this.fieldList = [];
    },
    getSelectedHospital(hospitalId) {
      return this.getAllHospitals.data
        .filter((hospital) => hospitalId.indexOf(hospital._id) != -1)
        .flatMap((hospital) => hospital.name)
        .join(", ");
    },
    getSelectedPhysician(physicianId) {
      return this.getAllPhysicians.data.find(
        (physician) => physician._id == physicianId
      );
    },
    getSelectedTest(tests) {
      return this.getAllLabTests
        .filter((test) => tests.indexOf(test._id) != -1)
        .flatMap((test) => test.name)
        .join(", ");
    },
    getSelectedUser(userId) {
      return this.getAllUsers.data
        .filter((user) => userId.indexOf(user._id) != -1)
        .flatMap((user) => user.first_name + " " + user.last_name)
        .join(", ");
    },
    getSelectedBillingUser(billingId) {
      return this.getAllUsers.data
        .filter((user) => billingId.indexOf(user._id) != -1)
        .flatMap((user) => user.first_name + " " + user.last_name)
        .join(", ");
    },
    prepareParams() {
      if (this.activeFieldList.length) {
        let params = {
          include: this.activeFieldList,
        };

        if (this.date_type) {
          params.date_type = this.date_type;
        }

        if (
          this.search_case_status &&
          Array.isArray(this.search_case_status) &&
          this.search_case_status.length > 1
        ) {
          params.case_status = this.search_case_status;
        } else if (this.search_case_status && this.search_case_status.length) {
          params.status = this.search_case_status.toString();
        } else if (Object.keys(params).indexOf("status") != -1) {
          delete params.status;
        }
        if (this.search_case_statuses) {
          params.status = this.search_case_statuses;
        }
        if (this.selected_string) {
          params.search_string = this.selected_string;
        }
        if (
          this.search_billed_status &&
          (this.search_billed_status.includes("Unbilled") ||
            this.search_billed_status.includes("PENDING"))
        ) {
          params.billing_status = this.search_billed_status;
        } else if (
          this.search_billed_status &&
          (this.search_billed_status.includes("Billed") ||
            this.search_billed_status.includes("Billed with Exception") ||
            this.search_billed_status.includes("Client") ||
            this.search_billed_status.includes("Coding") ||
            this.search_billed_status.includes("Exception") ||
            this.search_billed_status.includes("On hold") ||
            this.search_billed_status.includes("Patient"))
        ) {
          params.billing_status = [this.search_billed_status];
        }

        if (this.selected_emr) {
          params.emr = this.selected_emr;
        }
        if (this.selected_accession_id) {
          params.accession_id = this.selected_accession_id;
        }
        if (this.selected_case_type && this.selected_case_type.length) {
          params.case_types = [this.selected_case_type];
        }
        if (this.selected_case_types && this.selected_case_types.length) {
          params.case_types = this.selected_case_types;
        }
        if (this.selected_hospital != "") {
          params.hospitals = this.selected_hospital;
        }
        if (this.selected_user && this.selected_user.length) {
          params.test_performed_by = this.selected_user;
        }
        if (this.selected_marketer && this.selected_marketer.length) {
          params.hospital_marketers = this.selected_marketer;
        }
        if (this.selected_tests && this.selected_tests.length) {
          params.tests_info = [].concat.apply([], this.selected_tests);
        }
        if (this.selected_physician) {
          params.ordering_physician = this.selected_physician;
        }
        if (this.search_first_name) {
          params.patient_name = this.search_first_name;
        }
        if (this.search_last_name) {
          params.last_name = this.search_last_name;
        }
        if (this.selected_covid_status) {
          params.covid_status = this.selected_covid_status;
        }

        if (this.selected_dob) {
          const patient_dob = moment(this.selected_dob).format("YYYY-MM-DD");

          params.date_of_birth = patient_dob;
        }
        if (this.selected_from_date) {
          const slected_date = this.convertToLabUTC(this.selected_from_date);

          params.from_date = slected_date;
        }
        if (this.selected_to_date) {
          const selected_end_date = this.convertToLabUTC(
            this.selected_to_date,
            true
          );
          params.to_date = selected_end_date;
        }
        if (this.pregnancy) {
          params.pregnant = this.pregnancy;
        }
        if (this.selected_billing_assigne) {
          params.billing_representative = this.selected_billing_assigne;
        }
        if (this.sendout) {
          params.is_sendout = this.sendout;
        }
        if (this.emr_not_sent) {
          params.emr_result_not_sent = this.emr_not_sent;
        }
        if (this.selected_exception) {
          params.billing_sub_status = this.selected_exception;
        }
        if (this.search_billed_sub_status) {
          params.billing_sub_status = this.search_billed_sub_status;
        }
        if(this.replaced_insurance){
          params.replaced_insurance = this.replaced_insurance
        }
        if (this.priority  == 'Stat') {
          params.is_stat = true;
        }
        if (this.priority  == 'Routine') {
          params.is_stat = false;
        }
        if(this.fromDate){
          params.from_date = this.fromDate
        }
        if(this.toDate){
          params.to_date = this.toDate
        }
        if(this.isGowthamUser){
          params.is_old = true
        }
        return params;
      }
    },

    async downloadAmendedCases() {
      if (this.activeFieldList.length) {
        let params = this.prepareParams();
        if (this.selected_date_type) {
          params.date_type = "amendement_details.amendment_time";
        }
        this.loading = true;
        await this.$store.dispatch("cases/downloadCaseData", params);
        this.loading = false;
        if (this.getDownloadCaseDataStatus) {
          this.close();
        } else {
          this.$message({
            message: "Error in downloading cases",
            type: "error",
          });
        }
      } else {
        this.$message({
          message: "Please select the data fields.",
          type: "warning",
        });
      }
    },
    async downloadCases() {
      if (this.activeFieldList.length) {
        let params = this.prepareParams();
        if (this.selected_date_type) {
          params.date_type = this.selected_date_type;
        }
        this.loading = true;
        await this.$store.dispatch("cases/downloadCaseData", params);
        this.loading = false;
        if (this.getDownloadCaseDataStatus) {
          this.close();
        } else {
          this.$message({
            message: "Error in downloading cases",
            type: "error",
          });
        }
      } else {
        this.$message({
          message: "Please select the data fields.",
          type: "warning",
        });
      }
    },
    close() {
      this.$emit("close");
    },
    handleCheckAllChange() {
      this.activeFieldList = [];
      this.fieldList = [];
      this.casesExportFields.forEach((obj) => {
        this.fieldList.push(obj.value);
      });
      this.activeFieldList = this.fieldList;
    },
  },
};
</script>
<style lang="scss">
.select-fields {
  ul {
    -webkit-column-count: 3;
    column-count: 3;
    -webkit-column-gap: 20px;
    column-gap: 20px;
    li {
      &:not(:last-child) {
        margin-bottom: 5px;
      }
    }
  }
}
</style>